module.exports = __webpack_public_path__ + "media/marker/map-pin-active-5c3645d3.png";